<template>
  <div>
    <div class="toolbar">
      <el-input v-model="query.productNumber" clearable placeholder="产品编码" style="width:160px" @keyup.enter.native="search" />
      <el-input v-model="query.productName" clearable placeholder="产品名称" style="width:160px" @keyup.enter.native="search" />
      <el-select v-model="query.entityType" clearable placeholder="实体类型" style="width:140px">
        <el-option label="具体产品" value="01" />
        <el-option label="产品族" value="02" />
      </el-select>
      <el-button type="primary" icon="el-icon-search" @click="search">查询</el-button>
      <el-button type="success" icon="el-icon-setting" @click="openConfigure()">配置器</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="openEdit()">新增</el-button>
      <el-button type="danger" plain :disabled="!selection.length" @click="onDelete()">批量删除</el-button>
    </div>

    <el-table :data="list" border v-loading="loading" @selection-change="selection = $event">
      <el-table-column type="selection" width="48" align="center" />
      <el-table-column type="index" label="序号" width="60" align="center" :index="indexMethod" />
      <el-table-column prop="productNumber" label="产品编码" width="150" />
      <el-table-column prop="productName" label="产品名称" min-width="160" show-overflow-tooltip />
      <el-table-column label="实体类型" width="100" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.entityType === '02'" size="mini" type="warning">产品族</el-tag>
          <el-tag v-else size="mini">具体产品</el-tag>
        </template>
      </el-table-column>
      <el-table-column prop="parentName" label="所属产品族" width="140" show-overflow-tooltip />
      <el-table-column prop="unitName" label="单位" width="80" align="center" />
      <el-table-column prop="categoryName" label="分类" width="120" show-overflow-tooltip />
      <el-table-column label="物料类型" width="90" align="center">
        <template slot-scope="{ row }">{{ materialLabel(row.globalTypeOfMaterial) }}</template>
      </el-table-column>
      <el-table-column label="状态" width="80" align="center">
        <template slot-scope="{ row }">
          <el-tag v-if="row.active === '1'" size="mini" type="success">启用</el-tag>
          <el-tag v-else size="mini" type="info">禁用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="200" fixed="right" align="center">
        <template slot-scope="{ row }">
          <el-button type="text" :disabled="row.entityType !== '02'" @click="openConfigure(row.productId)">配置</el-button>
          <el-button type="text" @click="openEdit(row.productId)">修改</el-button>
          <el-button type="text" @click="copyRow(row.productId)">复制</el-button>
          <el-button type="text" style="color:#ef4444" @click="onDelete(row.productId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <list-pagination
      :total="total"
      :page="page"
      :page-size="pageSize"
      :page-sizes="[10, 20, 50, 100]"
      @current-change="onPage"
      @size-change="onSize"
    />

    <el-dialog :title="dialogTitle" :visible.sync="editVisible" width="760px" :close-on-click-modal="false">
      <el-tabs v-model="activeTab">
        <el-tab-pane label="基本信息" name="base">
          <el-form ref="form" :model="form" :rules="rules" label-width="100px">
            <el-form-item label="产品编码" prop="productNumber">
              <el-input v-model="form.productNumber" />
            </el-form-item>
            <el-form-item label="产品名称" prop="productName">
              <el-input v-model="form.productName" />
            </el-form-item>
            <el-form-item label="实体类型" prop="entityType">
              <el-radio-group v-model="form.entityType" @change="onEntityTypeChange">
                <el-radio label="01">具体产品</el-radio>
                <el-radio label="02">产品族</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item v-if="form.entityType === '01'" label="所属产品族">
              <el-select v-model="form.parentId" filterable clearable placeholder="可选，挂到产品族下" style="width:100%">
                <el-option
                  v-for="item in familyOptions"
                  :key="item.productId"
                  :label="item.productNumber + ' / ' + item.productName"
                  :value="item.productId"
                />
              </el-select>
            </el-form-item>
            <el-form-item label="单位" prop="unit">
              <el-select v-model="form.unit" filterable clearable placeholder="请选择单位" style="width:100%">
                <el-option v-for="item in unitOptions" :key="item.id" :label="item.dictLabel" :value="String(item.id)" />
              </el-select>
            </el-form-item>
            <el-form-item label="辅助单位">
              <el-select v-model="form.additionalUnit" filterable clearable placeholder="可选" style="width:100%">
                <el-option v-for="item in unitOptions" :key="'a-' + item.id" :label="item.dictLabel" :value="String(item.id)" />
              </el-select>
            </el-form-item>
            <el-form-item label="换算系数">
              <el-input-number v-model="form.conversionFactor" :min="0.000001" :precision="6" :controls="false" style="width:100%" placeholder="1主单位=系数辅助单位" />
            </el-form-item>
            <el-form-item label="安全库存">
              <el-input-number v-model="form.safetyStock" :min="0" :precision="5" :controls="false" style="width:100%" placeholder="低于此量触发库存预警" />
            </el-form-item>
            <el-form-item label="名义成本">
              <el-input-number v-model="form.nominalCost" :min="0" :precision="4" :controls="false" style="width:100%" />
            </el-form-item>
            <el-form-item label="成本对应量">
              <el-input-number v-model="form.costForNumber" :min="0.000001" :precision="4" :controls="false" style="width:100%" placeholder="默认1" />
            </el-form-item>
            <el-form-item label="分类" prop="categoryId">
              <el-select v-model="form.categoryId" filterable clearable placeholder="请选择分类" style="width:100%">
                <el-option v-for="item in categoryOptions" :key="item.id" :label="item.dictLabel" :value="String(item.id)" />
              </el-select>
            </el-form-item>
            <el-form-item label="物料类型">
              <el-select v-model="form.globalTypeOfMaterial" clearable style="width:100%">
                <el-option v-for="item in materialTypes" :key="item.value" :label="item.label" :value="item.value" />
              </el-select>
            </el-form-item>
            <el-form-item label="启用批次">
              <el-switch v-model="form.batchEvidence" active-value="1" inactive-value="0" />
            </el-form-item>
            <el-form-item label="启用">
              <el-switch v-model="form.active" active-value="1" inactive-value="0" />
            </el-form-item>
            <el-form-item label="说明">
              <el-input v-model="form.description" type="textarea" :rows="2" />
            </el-form-item>
          </el-form>
        </el-tab-pane>
        <el-tab-pane label="产品属性" name="attr">
          <div style="margin-bottom:8px">
            <el-button type="primary" size="mini" @click="addAttrRow">添加属性</el-button>
            <el-button size="mini" style="margin-left:6px" @click="pickFromMaster">从属性主数据添加</el-button>
          </div>
          <el-table :data="form.attrList" border size="small">
            <el-table-column label="属性编码" width="140">
              <template slot-scope="{ row }">
                <el-input v-model="row.attrCode" size="mini" placeholder="如 SIZE" />
              </template>
            </el-table-column>
            <el-table-column label="属性名称" min-width="140">
              <template slot-scope="{ row }">
                <el-input v-model="row.attrName" size="mini" placeholder="必填，如尺寸" />
              </template>
            </el-table-column>
            <el-table-column label="属性值" min-width="160">
              <template slot-scope="{ row }">
                <el-select v-if="(row._options || []).length" v-model="row.attrValue" filterable allow-create clearable size="mini" style="width:100%">
                  <el-option v-for="v in row._options" :key="v" :label="v" :value="v" />
                </el-select>
                <el-input v-else v-model="row.attrValue" size="mini" placeholder="如 M / 红色" />
              </template>
            </el-table-column>
            <el-table-column label="操作" width="70" align="center">
              <template slot-scope="{ $index }">
                <el-button type="text" size="mini" @click="form.attrList.splice($index, 1)">删</el-button>
              </template>
            </el-table-column>
          </el-table>
        </el-tab-pane>
      </el-tabs>
      <div slot="footer">
        <el-button @click="editVisible = false">取消</el-button>
        <el-button type="primary" :loading="saving" @click="submitEdit">确定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="产品配置器" :visible.sync="cfgVisible" width="640px" :close-on-click-modal="false" @close="cfgResult = null">
      <el-form label-width="100px">
        <el-form-item label="产品族" required>
          <el-select v-model="cfgFamilyId" filterable style="width:100%" placeholder="选择产品族" @change="onFamilyChange">
            <el-option v-for="f in cfgFamilies" :key="f.productId" :label="f.productNumber + ' / ' + f.productName" :value="f.productId" />
          </el-select>
        </el-form-item>
        <el-form-item v-for="(row, idx) in cfgSlots" :key="(row.attrCode || 'slot') + '_' + idx" :label="row.attrName || row.attrCode">
          <el-select v-if="(row.options || []).length" v-model="row.attrValue" filterable clearable allow-create default-first-option style="width:100%" placeholder="选择或输入">
            <el-option v-for="v in row.options" :key="v" :label="v" :value="v" />
          </el-select>
          <el-input v-else v-model="row.attrValue" placeholder="输入属性值" />
        </el-form-item>
        <el-form-item label="无匹配时">
          <el-switch v-model="createIfMissing" active-text="自动创建变体" inactive-text="仅查找" />
        </el-form-item>
        <el-alert type="info" :closable="false" title="目录编号规则：族编码-属性值1-属性值2…；相同属性组合会复用已有具体产品。" />
        <div v-if="cfgResult" class="cfg-result">
          <div>结果：{{ cfgResult.created ? '已新建' : '已匹配' }}</div>
          <div>编码：<strong>{{ cfgResult.product.productNumber }}</strong></div>
          <div>名称：{{ cfgResult.product.productName }}</div>
        </div>
      </el-form>
      <div slot="footer">
        <el-button @click="cfgVisible = false">关闭</el-button>
        <el-button type="primary" :loading="cfgSaving" @click="submitConfigure">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListPagination from '../../components/ListPagination.vue'
import { listDictOptions } from '../../api/dict'
import {
  listProduct, selectProduct, getProduct, saveProduct, updateProduct, deleteProduct,
  configureProduct
} from '../../api/product'
import { selectAttribute } from '../../api/attribute'

const MATERIAL_TYPES = [
  { value: '01', label: '零部件' },
  { value: '02', label: '半成品' },
  { value: '03', label: '成品' },
  { value: '04', label: '废料' },
  { value: '05', label: '包装' }
]

function emptyForm() {
  return {
    productId: '',
    productNumber: '',
    productName: '',
    unit: '',
    additionalUnit: '',
    conversionFactor: undefined,
    safetyStock: undefined,
    nominalCost: 0,
    costForNumber: 1,
    batchEvidence: '0',
    categoryId: '',
    globalTypeOfMaterial: '03',
    entityType: '01',
    parentId: '',
    active: '1',
    description: '',
    attrList: []
  }
}

export default {
  name: 'MesProductPage',
  components: { ListPagination },
  data() {
    return {
      query: { productNumber: '', productName: '', entityType: '' },
      list: [],
      total: 0,
      page: 1,
      pageSize: 20,
      loading: false,
      selection: [],
      editVisible: false,
      copying: false,
      saving: false,
      activeTab: 'base',
      form: emptyForm(),
      unitOptions: [],
      categoryOptions: [],
      familyOptions: [],
      attrMaster: [],
      materialTypes: MATERIAL_TYPES,
      rules: {
        productNumber: [{ required: true, message: '产品编码不能为空', trigger: 'blur' }],
        productName: [{ required: true, message: '产品名称不能为空', trigger: 'blur' }],
        unit: [{ required: true, message: '请选择单位', trigger: 'change' }],
        categoryId: [{ required: true, message: '请选择分类', trigger: 'change' }],
        entityType: [{ required: true, message: '请选择实体类型', trigger: 'change' }]
      },
      cfgVisible: false,
      cfgFamilyId: '',
      cfgFamilies: [],
      cfgSlots: [],
      createIfMissing: true,
      cfgSaving: false,
      cfgResult: null
    }
  },
  computed: {
    dialogTitle() {
      if (this.copying) return '复制产品'
      return this.form.productId ? '修改产品' : '新增产品'
    }
  },
  created() {
    this.load()
  },
  methods: {
    materialLabel(code) {
      const hit = MATERIAL_TYPES.find(x => x.value === code)
      return hit ? hit.label : (code || '')
    },
    indexMethod(index) {
      return (this.page - 1) * this.pageSize + index + 1
    },
    search() {
      this.page = 1
      this.load()
    },
    onPage(p) {
      this.page = p
      this.load()
    },
    onSize(s) {
      this.pageSize = s
      this.page = 1
      this.load()
    },
    load() {
      this.loading = true
      listProduct({
        currentPage: this.page,
        pageSize: this.pageSize,
        productNumber: this.query.productNumber,
        productName: this.query.productName,
        entityType: this.query.entityType
      }).then(res => {
        const body = res.data || {}
        this.list = body.list || []
        this.total = body.totalCount || 0
      }).finally(() => { this.loading = false })
    },
    onDelete(id) {
      const ids = id ? [id] : this.selection.map(item => item.productId)
      if (!ids.length) return
      this.$confirm('确定删除所选产品?', '提示', { type: 'warning' }).then(() => {
        deleteProduct(ids).then(() => {
          this.$message.success('操作成功')
          this.load()
        })
      }).catch(() => {})
    },
    openEdit(id) {
      this.copying = false
      this.editVisible = true
      this.activeTab = 'base'
      this.form = emptyForm()
      this.loadDictOptions()
      this.loadAttrMaster()
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      if (id) {
        getProduct(id).then(res => {
          const product = res.data || {}
          this.form = Object.assign(emptyForm(), product)
          if (!this.form.batchEvidence) this.form.batchEvidence = '0'
          if (!this.form.entityType) this.form.entityType = '01'
          if (!this.form.attrList) this.form.attrList = []
          this.form.attrList.forEach(row => { if (!row._options) this.$set(row, '_options', []) })
          this.loadFamilies()
        })
      } else {
        this.loadFamilies()
      }
    },
    copyRow(id) {
      this.copying = true
      this.editVisible = true
      this.activeTab = 'base'
      this.form = emptyForm()
      this.loadDictOptions()
      this.loadAttrMaster()
      this.$nextTick(() => this.$refs.form && this.$refs.form.clearValidate())
      getProduct(id).then(res => {
        const product = res.data || {}
        const form = Object.assign(emptyForm(), product)
        form.productId = ''
        form.productNumber = (product.productNumber || '') + '-副本'
        form.productName = (product.productName || '') + ' 副本'
        form.attrList = (product.attrList || []).map(row => ({
          attrCode: row.attrCode,
          attrName: row.attrName,
          attrValue: row.attrValue,
          _options: []
        }))
        if (!form.batchEvidence) form.batchEvidence = '0'
        if (!form.entityType) form.entityType = '01'
        this.form = form
        this.loadFamilies()
      })
    },
    onEntityTypeChange(v) {
      if (v === '02') this.form.parentId = ''
    },
    addAttrRow() {
      if (!this.form.attrList) this.form.attrList = []
      this.form.attrList.push({ attrCode: '', attrName: '', attrValue: '', _options: [] })
    },
    pickFromMaster() {
      if (!(this.attrMaster || []).length) {
        this.$message.warning('请先在「产品属性」维护属性主数据')
        return
      }
      this.$prompt('输入属性编码（如 SIZE）', '从主数据添加', {
        confirmButtonText: '确定',
        cancelButtonText: '取消'
      }).then(({ value }) => {
        const code = (value || '').trim()
        const m = this.attrMaster.find(a => (a.attrCode || '').toUpperCase() === code.toUpperCase())
        if (!m) {
          this.$message.warning('未找到该属性编码')
          return
        }
        if (!this.form.attrList) this.form.attrList = []
        this.form.attrList.push({
          attrCode: m.attrCode,
          attrName: m.attrName,
          attrValue: '',
          _options: (m.valueList || []).map(v => v.attrValue)
        })
      }).catch(() => {})
    },
    loadAttrMaster() {
      selectAttribute().then(res => { this.attrMaster = res.data || [] }).catch(() => {})
    },
    loadFamilies() {
      selectProduct('02').then(res => {
        const list = res.data || []
        this.familyOptions = list.filter(p => p.productId !== this.form.productId)
      }).catch(() => {})
    },
    loadDictOptions() {
      listDictOptions('UNIT').then(res => { this.unitOptions = res.data || [] }).catch(() => {})
      listDictOptions('categories').then(res => { this.categoryOptions = res.data || [] }).catch(() => {})
    },
    submitEdit() {
      this.$refs.form.validate(valid => {
        if (!valid) {
          this.activeTab = 'base'
          return
        }
        const payload = Object.assign({}, this.form)
        if (payload.entityType === '02') payload.parentId = ''
        payload.attrList = (payload.attrList || []).map(row => ({
          attrCode: row.attrCode,
          attrName: row.attrName,
          attrValue: row.attrValue
        }))
        this.saving = true
        const req = payload.productId ? updateProduct(payload) : saveProduct(payload)
        req.then(() => {
          this.$message.success('操作成功')
          this.editVisible = false
          this.load()
        }).finally(() => { this.saving = false })
      })
    },
    openConfigure(familyId) {
      this.cfgVisible = true
      this.cfgFamilyId = familyId || ''
      this.cfgSlots = []
      this.cfgResult = null
      this.createIfMissing = true
      selectProduct('02').then(res => { this.cfgFamilies = res.data || [] }).catch(() => {})
      selectAttribute().then(res => {
        this.attrMaster = res.data || []
        if (this.cfgFamilyId) this.onFamilyChange(this.cfgFamilyId)
        else this.buildSlotsFromMaster()
      }).catch(() => {})
    },
    onFamilyChange(id) {
      this.cfgResult = null
      if (!id) {
        this.buildSlotsFromMaster()
        return
      }
      getProduct(id).then(res => {
        const product = res.data
        if (!product) return
        const familyAttrs = product.attrList || []
        if (familyAttrs.length) {
          this.cfgSlots = familyAttrs.map(a => ({
            attrCode: a.attrCode || a.attrName,
            attrName: a.attrName || a.attrCode,
            attrValue: a.attrValue || '',
            options: this.optionsForCode(a.attrCode || a.attrName)
          }))
        } else {
          this.buildSlotsFromMaster()
        }
      })
    },
    buildSlotsFromMaster() {
      this.cfgSlots = (this.attrMaster || []).map(a => ({
        attrCode: a.attrCode,
        attrName: a.attrName,
        attrValue: '',
        options: (a.valueList || []).map(v => v.attrValue)
      }))
    },
    optionsForCode(code) {
      if (!code) return []
      const m = (this.attrMaster || []).find(a => (a.attrCode || '').toUpperCase() === String(code).toUpperCase())
      return m && m.valueList ? m.valueList.map(v => v.attrValue) : []
    },
    submitConfigure() {
      if (!this.cfgFamilyId) {
        this.$message.warning('请选择产品族')
        return
      }
      const attrs = this.cfgSlots
        .filter(s => s.attrValue)
        .map(s => ({ attrCode: s.attrCode, attrName: s.attrName, attrValue: s.attrValue }))
      if (!attrs.length) {
        this.$message.warning('请至少填写一个属性值')
        return
      }
      this.cfgSaving = true
      configureProduct({
        familyId: this.cfgFamilyId,
        attrs,
        createIfMissing: this.createIfMissing
      }).then(res => {
        const data = res.data || {}
        this.cfgResult = { product: data.product, created: !!data.created }
        this.$message.success(data.created ? '已创建具体产品' : '已匹配已有产品')
        this.load()
      }).finally(() => { this.cfgSaving = false })
    }
  }
}
</script>

<style scoped>
.cfg-result {
  margin-top: 12px;
  padding: 8px 12px;
  background: #f8fafc;
  border-radius: 6px;
  line-height: 1.7;
}
</style>
